import Vue from 'vue'
import _ from 'lodash'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    defaultPagination: {
      q: '',
      sortBy: 'name',
      page: 1,
      rowsPerPage: 10,
      descending: false,
      totalItems: 0
    }
  },
  actions: {
    fetchItem ({ commit, dispatch }, payload) {
      return Vue.axios.get(`${config.serverURI}/customers/${payload}`).then((response) => {
        if (response.data.address == null) {
          response.data.address = {
            addressNo: null,
            tambon: {},
            district: {},
            province: {},
            zipcode: null,
            phone: null,
            fax: null}
        }
        return response
      }).catch((error) => {
        return Promise.reject(error)
      })
    },
    create ({ commit, dispatch }, payload) {
      return Vue.axios.post(`${config.serverURI}/customers`, payload)
    },
    update ({ commit, dispatch }, payload) {
      return Vue.axios.put(`${config.serverURI}/customers/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      return Vue.axios.put(`${config.serverURI}/customers/${payload.id}`, {enabled: false})
    },
    loadItems ({commit, state, getters}, pagination) {
      if (!pagination) pagination = getters.defaultPagination
      return Vue.axios.get(config.serverURI + '/customers/page', { params: pagination })
    },
    loadCustomerItems ({commit, state}) {
      return Vue.axios.get(config.serverURI + '/customers')
    }
  },
  getters: {
    defaultPagination (state) {
      return state.defaultPagination
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customer.js